"use client";

import { useState, useEffect } from "react";

import { Spinner } from "@nextui-org/react";
import { TwoLevelSelector } from "@/app/indicators/investigator/(components)/TwoLevelSelector";
import { IndicatorsContext } from "@/app/indicators/(context)/IndicatorsContext";
import dynamic from "next/dynamic";
import { useRouter } from "next13-progressbar";
import { fetchAreasNetworks } from "@/app/indicators/investigator/actions/areasInvestigator";
import { fetchCollaborationsByArea } from "@/app/indicators/investigator/actions/areasInvestigator";
import { fetchAuthorsByArea } from "@/app/indicators/investigator/actions/areasInvestigator";


const PackedBubbleMassive = dynamic(
  () => import("@/app/charts/PackedBubbleMassive"),
  {
    ssr: false,
    loading: () => (
      <div className="flex justify-center items-center w-full h-96">
        <Spinner size="large" label="Cargando resultados" />
      </div>
    ),
  }
);

const NetworkChart = dynamic(() => import("@/app/charts/NetworkChart"), {
  ssr: false,
  loading: () => (
    <div className="flex justify-center items-center w-full h-96">
      <Spinner size="large" label="Cargando resultados" />
    </div>
  ),
});

export default function IndicatorsInvestigatorNetworksPage() {
  const router = useRouter();

  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);

  const [series, setSeries] = useState([]);
  const [edges, setEdges] = useState([]);
  const [nodes, setNodes] = useState([]);

  // Estas variables guardan los valores seleccionados
  const [level1Value, setLevelValue1] = useState(0);
  const [level2Value, setLevelValue2] = useState(-1);

  // Estas variables guardan los valores de los selectores
  const [dataSelector1, setDataSelector1] = useState([]);
  const [dataSelector2, setDataSelector2] = useState([]);

  // Loading areas
  const [loading, setLoading] = useState(true);

  function handleNodeClick(authorId) {
    router.push(`/author/${authorId}`);
  }


  useEffect(() => {
    setLoading(true);
    fetchAreasNetworks().then((resp) => {
      resp = resp.map(({ index, count, label }) => {
        return {
          index: +index,
          label,
          count,
        };
      });
      setData(resp);
      setLoading(false);
    });
  }, []);



  const addNode = (array, author) => {
    // Agrega el nodo si no existe
    if (!array.find((node) => node.id === author.authorId)) {
      let img = `/autoricon.png`; // default image
      if (author.image_1) {
        img = author.image_1;
      }

      // Obtener todos los mainAcron de las universidades
      let org = "Organización no registrada";
      if (author.universities.length > 0) {
        org = author.universities
          .map((university) => university.mainAcron)
          .join(", ");
      }
      array.push({
        id: author.authorId,
        label: author.label,
        org,
        img,
      });
    }
    return array;
  };

  const addEdge = (array, author1, author2) => {
    // Agrega el edge si no existe
    if (
      !array.find(
        (edge) =>
          edge.source === author1.authorId && edge.target === author2.authorId
      ) &&
      !array.find(
        (edge) =>
          edge.source === author2.authorId && edge.target === author1.authorId
      )
    ) {
      array.push({
        source: author1.authorId,
        target: author2.authorId,
      });
    }
    return array;
  };

  useEffect(() => {
    if (filteredData.length === 0) return;
    setLoading(true);
    const areasIds = filteredData.map(({ index }) => index);
    const areasIdsString = areasIds.map((id) => id.toString().padStart(3, "0"));
    if (filteredData.length === 1) {
      fetchCollaborationsByArea(areasIdsString).then((resp) => {
        let edgesAux = [];
        let nodesAux = [];
        resp.forEach(({ authorsCollaborations }) => {
          authorsCollaborations.forEach(({ author1, author2 }) => {
            edgesAux = addEdge(edgesAux, author1, author2);
            nodesAux = addNode(nodesAux, author1);
            nodesAux = addNode(nodesAux, author2);
          });
        });

        setNodes(nodesAux);
        setEdges(edgesAux);
        setLoading(false);
      });
    } else {
      fetchAuthorsByArea(areasIdsString).then((resp) => {
        const respAuxArray = [];
        resp.forEach(({ labelEs, authors }) => {
          const respAux = {
            name: labelEs,
            data: authors.map(({ authorId, label }) => {
              return { label: authorId, value: 1, name: label };
            }),
          };
          respAuxArray.push(respAux);
        });
        setSeries(respAuxArray);
        setLoading(false);
      });
    }
  }, [filteredData]);

  return (
    <IndicatorsContext.Provider
      value={{
        data,
        level1Value,
        level2Value,
        dataSelector1,
        dataSelector2,
        setFilteredData,
        setLevelValue1,
        setLevelValue2,
        setDataSelector1,
        setDataSelector2,
        setLoading,
      }}
    >
      <div className="text-left">
        <TwoLevelSelector />
        {loading ? (
          <div className="flex justify-center items-center w-full h-96">
            <Spinner size="large" label="Cargando resultados" />
          </div>
        ) : filteredData.length === 1 ? (
          <div className="shadow-sm">
            <NetworkChart
              edges={edges}
              nodes={nodes}
              handleNodeClick={handleNodeClick}
            />
          </div>
        ) : (
          filteredData.length > 1 && (
            <PackedBubbleMassive
              series={series}
              handleNodeClick={handleNodeClick}
            />
          )
        )}
      </div>
    </IndicatorsContext.Provider>
  );
}
